import {HTTP} from '../http-common';
import discovery from '../discovery';

export default {
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            //'authorization': 'Bearer ' + window.kc_token
        };
 
        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(discovery.magnolia_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(discovery.magnolia_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                if (cbok)
                    cbok(response.data);
            }).catch(function (error) {
                if (cberr)
                    cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(discovery.magnolia_service_url+service,
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(discovery.magnolia_service_url+service,
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },

    /////////////////////////////////////////////////////////////////
    //COMMON 
    getPosts (cbok, cberr)
    {
        this.genericGet('delivery/posts', cbok, cberr);
    },
}
